import useIcons from "../hooks/useIcons";
import { iconNames } from "./icon-names";

const { withIcons } = useIcons();

export const  RequestFieldKeys = {
  REQ_NUMBER: "requestNumber",
  STATUS: "status",
  BRAND: "brand",
  MODEL: "model",
  YEAR_OF_MANUFACTURE: "yearOfManufacture",
  ODOMETER: "odometer",
  VIN: "vin",
  TIME: "time",
  STATE_NUMBER: "stateNumber",
  PLADGE_STATUS: 'pledgeStatus',
  CREDIT_HISTORY_STATUS: 'status',
  DESIRED_AMOUNT: "desiredAmount",
  DESIRED_AMOUNT_COMMENT: "desiredAmountComment",
  DESIRED_TERM: "desiredTerm",
  DESIRED_TERM_COMMENT: "desiredTermComment",
  ESTIMATED_VALUE: "estimatedValue",
  MAX_LOAN_AMOUNT: "maxLoanAmount",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  MIDDLE_NAME: "middleName",
  BIRTH_DATE: "birthDate",
  PERSONAL_NUMBER: "personalNumber",
  EMAIL: "email",
  PHONE: "phone",
  JOB_INDUSTRY: "jobIndustry",
  LASTJOB_DURATION: "lastJobDuration",
  JOB_TYPE: "jobType",
  OTHERJOB_TYPE: "otherJobType",
  AVG_MONTHLY_INCOME: "avgMonthlyIncome",
  EDUCATION: "education",
  FAMILY_STATUS: "familyStatus",
  NUMBER_OF_CHILDREN: "numberOfChildren",
  ACCOMODATION_TYPE: "accommodationType",
  NO_CREDIT_HISTORY: "noCreditHistory",
  ACCESS_DENIED_BY_CLIENT: "accessDeniedByClient",
  CALCULATION_DATE: "calculationDate",
  CREDIT_AMOUNT_SUM: "creditAmountSum",
  CREDIT_OVERDUE_SUM: "creditOverdueSum",
  TOTAL_SURETY_SUM: "totalSuretySum",
  TOTAL_PAYMENT_SUM: "totalPaymentSum",
  INCOME_VERIFICATION: "incomeVerificationDocument",
};

export const requestsData = {
  [RequestFieldKeys.REQ_NUMBER]: "Номер заявки",
  [RequestFieldKeys.STATUS]: "Статус",
  [RequestFieldKeys.BRAND]: "Марка автомобиля",
  [RequestFieldKeys.MODEL]: "Модель автомобиля",
  [RequestFieldKeys.YEAR_OF_MANUFACTURE]: "Год выпуска",
  [RequestFieldKeys.ODOMETER]: "Пробег",
  [RequestFieldKeys.VIN]: "Vin-номер",
  [RequestFieldKeys.PLADGE_STATUS]: "Залоговый статус",
  [RequestFieldKeys.STATE_NUMBER]: "Гос номер",
  [RequestFieldKeys.DESIRED_AMOUNT]: "Желаемая сумма займа",
  [RequestFieldKeys.DESIRED_TERM]: "Желательный срок займа",
  [RequestFieldKeys.ESTIMATED_VALUE]: "Оценочная стоимость",
  [RequestFieldKeys.MAX_LOAN_AMOUNT]: "Максимальная сумма к выдаче",
};

export const requestClientData = {
  [RequestFieldKeys.LAST_NAME]: "Фамилия клиента",
  [RequestFieldKeys.FIRST_NAME]: "Имя клиента",
  [RequestFieldKeys.MIDDLE_NAME]: "Отчество клиента",
  [RequestFieldKeys.BIRTH_DATE]: "Дата рождения",
  [RequestFieldKeys.EMAIL]: "Электронная почта",
  [RequestFieldKeys.PHONE]: "Телефон",
  [RequestFieldKeys.PERSONAL_NUMBER]: "Идентификационный номер",
  [RequestFieldKeys.JOB_TYPE]: "Тип занятости",
  [RequestFieldKeys.LASTJOB_DURATION]: "Стаж работы на последнем месте работы",
  [RequestFieldKeys.JOB_INDUSTRY]: "Сфера деятельности",
  [RequestFieldKeys.OTHERJOB_TYPE]: "Иной тип занятости",
  [RequestFieldKeys.AVG_MONTHLY_INCOME]: "Среднемесячный доход",
  [RequestFieldKeys.INCOME_VERIFICATION]: "Наличие документов, подтверждающих доход",
  [RequestFieldKeys.EDUCATION]: "Образование",
  [RequestFieldKeys.FAMILY_STATUS]: "Семейное положение", 
  [RequestFieldKeys.NUMBER_OF_CHILDREN]: "Наличие несовершеннолетних детей (до 18лет)",
  [RequestFieldKeys.ACCOMODATION_TYPE]: "Жилищные условия",
  [RequestFieldKeys.NO_CREDIT_HISTORY]: "Наличие кредитной истории в КБ",
  [RequestFieldKeys.ACCESS_DENIED_BY_CLIENT]: "Запрет на получение кредитной истории",
};

export const requestCreditHistory = {
  [RequestFieldKeys.CREDIT_HISTORY_STATUS]: "Статус",
  [RequestFieldKeys.TIME]: "Дата и время",
}

export const calculationCreditHistory = {
  [RequestFieldKeys.CALCULATION_DATE]: "Дата расчета",
  [RequestFieldKeys.CREDIT_AMOUNT_SUM]: "Сумма ежемесячных платежей по кредитам",
  [RequestFieldKeys.CREDIT_AMOUNT_SUM]: "Сумма ежемесячных платежей по кредитам",
  [RequestFieldKeys.CREDIT_OVERDUE_SUM]: "Сумма просроченных платежей по кредитам",
  [RequestFieldKeys.TOTAL_SURETY_SUM]: "Сумма платежей по договорам поручительства",
  [RequestFieldKeys.TOTAL_PAYMENT_SUM]: "Общая сумма ежемесячных платежей",
}

export const RequestFields = {
  ...requestsData,
  ...requestClientData
};

export const PhotoTypes = {
  AUTO: "photos",
  DOCUMENT: "files",
};

export const tabs = withIcons([
  { link: "requests", label: "Заявки", iconName: iconNames.WORK },
  { link: "changes", label: "Изменение заявок", iconName: iconNames.EDIT_REQUEST },
]);

export const RequestStatuses = {
  CREATED: "CREATED", // Создана
  IN_PROGRESS: "IN_PROGRESS", // В работе
  REQUIRES_REVISION: "REQUIRES_REVISION", // Требует изменений
  SCORING_REQUESTED: "SCORING_REQUESTED", // Отправлена в скоринг
  SCORING_APPROVED: "SCORING_APPROVED", // Одобрена скорингом
  REJECTED_BY_ADMIN: "REJECTED_BY_ADMIN", // Отклонена
  REJECTED_BY_CLIENT : "REJECTED_BY_CLIENT", // Отклонена
  APPROVED: "APPROVED", // Одобрена
  AWAITING_SIGNATURE: "AWAITING_SIGNATURE", // Ожидает подписания
  DOCUMENTS_SIGNED: "DOCUMENTS_SIGNED", // Документ подписан
  ACTIVE_NO_COLLATERAL_INFO: "ACTIVE_NO_COLLATERAL_INFO", // Информация о залоге не внесена
  ACTIVE: "ACTIVE", // Активная
  EXPIRED: "EXPIRED", // Просрочена
  COMPLETED_PENDING_WITHDRAWAL: "COMPLETED_PENDING_WITHDRAWAL", // Завершена (Не снята с залога)
  COMPLETED: "COMPLETED", // Завершена
  EARLY_CLOSURE_NOT_REPAID: "EARLY_CLOSURE_NOT_REPAID", // Досрочное закрытие (Не погашено)
  EARLY_CLOSURE_PENDING_WITHDRAWAL: "EARLY_CLOSURE_PENDING_WITHDRAWAL", // Завершена досрочно (Не снята с залога)
  EARLY_CLOSURE: "EARLY_CLOSURE", // Завершена досрочно
  DEAL_CANCELED: "DEAL_CANCELED", // Договор расторгнут
};

export const extendedRequestStatuses = {
  ...RequestStatuses,
  SAVE: 'SAVE',
  CANCEL_CLARIFICATION: 'CANCEL_CLARIFICATION',
  CREATE_CLIENT: 'CREATE_CLIENT',
  DEBT_LOAD: 'DEBT_LOAD',
  CANCEL: 'CANCEL',
  REQUEST_CREDIT_REGISTER: 'REQUEST_CREDIT_REGISTER',
}

export const RequestStatus = {
  CREATED: { key: RequestStatuses.CREATED, label: "Создана" },
  IN_PROGRESS: { key: RequestStatuses.IN_PROGRESS, label: "В работе" },
  REQUIRES_REVISION: {
    key: RequestStatuses.REQUIRES_REVISION,
    label: "Требует изменений",
  },
  SCORING_REQUESTED: {
    key: RequestStatuses.SCORING_REQUESTED,
    label: "Отправлена в скоринг",
  },
  SCORING_APPROVED: {
    key: RequestStatuses.SCORING_APPROVED,
    label: "Одобрена скорингом",
  },
  REJECTED_BY_ADMIN: { key: RequestStatuses.REJECTED_BY_ADMIN, label: "Отклонена администратором" },
  REJECTED_BY_CLIENT: { key: RequestStatuses.REJECTED_BY_CLIENT, label: "Отклонена клиентом" },
  APPROVED: { key: RequestStatuses.APPROVED, label: "Одобрена" },
  AWAITING_SIGNATURE: {
    key: RequestStatuses.AWAITING_SIGNATURE,
    label: "Ожидает подписания",
  },
  DOCUMENTS_SIGNED: {
    key: RequestStatuses.DOCUMENTS_SIGNED,
    label: "Документ подписан",
  },
  ACTIVE_NO_COLLATERAL_INFO: {
    key: RequestStatuses.ACTIVE_NO_COLLATERAL_INFO,
    label: "Активная / Инф. о залоге не внесена",
  },
  ACTIVE: { key: RequestStatuses.ACTIVE, label: "Активная" },
  EXPIRED: { key: RequestStatuses.EXPIRED, label: "Просрочена" },
  COMPLETED_PENDING_WITHDRAWAL: {
    key: RequestStatuses.COMPLETED_PENDING_WITHDRAWAL,
    label: "Завершена (Не снята с залога)",
  },
  COMPLETED: { key: RequestStatuses.COMPLETED, label: "Завершена" },
  EARLY_CLOSURE_NOT_REPAID: {
    key: RequestStatuses.EARLY_CLOSURE_NOT_REPAID,
    label: "Досрочное закрытие (Не погашено)",
  },
  EARLY_CLOSURE_PENDING_WITHDRAWAL: {
    key: RequestStatuses.EARLY_CLOSURE_PENDING_WITHDRAWAL,
    label: "Завершена досрочно (Не снята с залога)",
  },
  EARLY_CLOSURE: {
    key: RequestStatuses.EARLY_CLOSURE,
    label: "Завершена досрочно",
  },
  DEAL_CANCELED: {
    key: RequestStatuses.DEAL_CANCELED,
    label: "Договор расторгнут",
  },
  MODIFIED: { key: "MODIFIED", label: "Изменена" },
  PENDING_PAYOUT: { key: "PENDING_PAYOUT", label: "Ожидает выплаты" },
};

export const buttons = [
  {
    key: extendedRequestStatuses.SAVE,
    label: "Сохранить уточнения",
    statuses: [extendedRequestStatuses.SAVE],
    type: 'submit'
  },
  {
    key: extendedRequestStatuses.CANCEL_CLARIFICATION,
    label: "Отменить уточнения",
    statuses: [extendedRequestStatuses.SAVE],
  },
  {
    key: RequestStatuses.CREATED,
    label: "В работу",
    statuses: [RequestStatus.CREATED.key, RequestStatus.MODIFIED.key, RequestStatus.REJECTED_BY_CLIENT.key],
  },
  {
    key: RequestStatuses.EXPIRED,
    label: "Расторгнуть договор",
    statuses: [RequestStatus.EXPIRED.key],
  },
  {
    key: RequestStatuses.ACTIVE_NO_COLLATERAL_INFO,
    label: "Добавить авто в реестр залогов",
    statuses: [RequestStatus.ACTIVE_NO_COLLATERAL_INFO.key],
  },
  {
    key: RequestStatuses.COMPLETED_PENDING_WITHDRAWAL,
    label: "Снять авто с залога",
    statuses: [
      RequestStatus.COMPLETED_PENDING_WITHDRAWAL.key,
      RequestStatus.EARLY_CLOSURE_PENDING_WITHDRAWAL.key,
    ],
  },
  {
    key: RequestStatuses.APPROVED,
    label: "Одобрить",
    statuses: [RequestStatus.IN_PROGRESS.key],
  },
  {
    key: RequestStatuses.REJECTED_BY_ADMIN,
    label: "Отклонить",
    statuses: [RequestStatus.IN_PROGRESS.key, RequestStatus.APPROVED.key],
  },
  {
    key: RequestStatuses.REQUIRES_REVISION,
    label: "Требует изменений",
    statuses: [RequestStatus.IN_PROGRESS.key],
  },
  {
    key: extendedRequestStatuses.CANCEL,
    label: "Отмена заявки",
    statuses: [
      RequestStatus.AWAITING_SIGNATURE.key,
      RequestStatus.DOCUMENTS_SIGNED.key,
    ],
  },
  {
    key: extendedRequestStatuses.CREATE_CLIENT,
    label: "Создать клиента в OneApp",
    statuses: [extendedRequestStatuses.CREATE_CLIENT],
  },
  {
    key: extendedRequestStatuses.DEBT_LOAD,
    label: "Рассчитать ПДН",
    statuses: [RequestStatus.IN_PROGRESS.key],
  },
];

export const requestStatus = Object.values(RequestStatus);

export const rejectReasons = [
  {
    value: "VEHICLE_REGISTERED",
    label: "Ваш автомобиль находится в реестре залогов",
  },
  { value: "CREDIT_CHECK_FAILED", label: "Вы не прошли кредитную проверку" },
  { value: "POOR_PHOTO_QUALITY", label: "Ваши фото ненадлежащего качества" },
  {
    value: "WRONG_VEHICLE_INFO",
    label: "Вы указали неверную информацию об автомобиле",
  },
  { value: "NOT_OWNER", label: "Вы не являетесь владельцем автомобиля" },
];

export const rangeSliders = (requestDetails) => [
  {
    label: "Сумма заявки, руб",
    name: "approvedAmount",
    min: 0,
    max: requestDetails.estimatedValue,
    initialValue: requestDetails.desiredAmount,
    isVisibleRange: true,
    readOnly: false,
  },
  {
    label: "Срок заявки, мес.",
    name: "approvedTerm",
    min: 1,
    max: 25,
    initialValue: requestDetails?.desiredTerm,
    isVisibleRange: true,
    readOnly: false,
  },
  {
    label: "Оценочная стоимость, руб.",
    name: "estimatedValue",
    min: 1,
    max: 1000000,
    initialValue: requestDetails?.estimatedValue,
    isVisibleRange: false,
    readOnly: true,
  },
];

export const JobTenure = {
  LESS_THAN_1_YEAR: "Менее 1 года",
  FROM_1_TO_3_YEARS: "1-3 года",
  MORE_THAN_3_YEARS: "Более 3 лет",
};

export const JobType = {
  EMPLOYMENT_CONTRACT: "Работа по трудовому договору (РБ)",
  SERVICE_CONTRACT: "Выполнение работ (услуг) по договору подряда (РБ)",
  CONTRACT_ABROAD: "Работа по трудовому договору за рубежом",
  INDIVIDUAL_ENTREPRENEUR: "Индивидуальный предприниматель",
  SELF_EMPLOYED: "Самозанятый",
  CRAFTSMAN: "Ремесленник",
  CHILD_CARE_LEAVE: "Отпуск по уходу за ребенком до 3 лет",
  RETIRED_AGE: "Пенсия по возрасту (неработающий пенсионер)",
  RETIRED_DISABILITY: "Пенсия по инвалидности",
  OTHER: "Иное",
};

export const Education = {
  OTHER: 'Другое',
  GENERAL_SECONDARY: 'Общее среднее', 
  VOCATIONAL: 'Профессионально-техническое',
  SECONDARY_SPECIAL: 'Cреднее специальное',
  HIGHER: 'Высшее'
}

export const FamilyStatus = {
  MARRIED: 'Женат / замужем',
  SINGLE: 'Холост / не замужем'
}

export const AccommodationType = {
  OWNED: 'Собственное жилье',
  RENTED: 'Арендное жилье',
  RELATIVES: 'Жилье в собственности родителей(родственноков)'
}

export const AutolombardDocumentTypes = {
  PERSONAL_DATA_AGREEMENT: "PERSONAL_DATA_AGREEMENT",
  CREDIT_REPORT_AGREEMENT: "CREDIT_REPORT_AGREEMENT",
  ADS_AGREEMENT: "ADS_AGREEMENT",
  CLIENT_FORM: "CLIENT_FORM",
  INCOME_VERIFICATION: "INCOME_VERIFICATION",
  MONTHLY_PAYMENT_CALCULATION: "MONTHLY_PAYMENT_CALCULATION"
};

export const kbMessage = 'Не получен ответ из Кредитного реестра'

export const PladgeStatus = {
  UNKNOWN: 'Не известно',
  IN_PLEDGE: 'В залоге',
  NOT_IN_PLEDGE: 'Не в залоге'
}